/* eslint semi:0 */
import { namespacedConsts, } from 'utils/object'
import { dispatchAction, } from 'application/AppDispatcher'

const CLASS_CONSTATNTS = namespacedConsts({
  LAZY_LOAD: {
    ACTIONS: {
      REACHED_LOAD_TARGET: true,
    },
  },
})

const TYPES = CLASS_CONSTATNTS.LAZY_LOAD.ACTIONS

const lazyLoadActions = {

  TYPES,

  loadTargetReached(scrollingEventObject){
    dispatchAction.view({
      type: TYPES.REACHED_LOAD_TARGET,
      scrollingEventObject,
    })
  },

}

export default lazyLoadActions


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/lazyLoadActions.js